import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent {
  @Input() text: string = 'Botão';
  @Input() variant: 'primary' | 'white' = 'primary';
  @Input() icon?: string;
  @Input() disabled: boolean = false;
  @Input() routerLink?: string | any[];
  @Input() fragment?: string;

  constructor(private router: Router) {}

  navigate(): void {
    if (!this.fragment) return;

    this.router.navigate([], {
      fragment: undefined,
      queryParamsHandling: 'preserve',
    }).then(() => {

      this.router.navigate(
        Array.isArray(this.routerLink)
          ? this.routerLink
          : [this.routerLink ?? '.'],
        {
          fragment: this.fragment,
          queryParamsHandling: 'preserve',
        }
      );
    });
  }
}
